import React from 'react'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import SimpleDatepicker from '../../../../../../common/inputs/datepicker/SimpleDatepicker'

const StartRentalDate: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  screenName,
  insertionData,
  wrapperClassName = 'grid-item one-half desk-padding-left-m lap-padding-left-m palm-padding-right',
  onChange,
  validationMessages,
}) => {
  const id = 'start-rental-date'
  const labelTranslationKey = 'wizard.screen.basicInfo.startRentalDate'
  const propertyName = 'startRentalDate'
  const errors = validationMessages?.startRentalDate ?? []
  const selectedDate = insertionData.startRentalDate
  return (
    <SimpleDatepicker
      id={id}
      propertyName={propertyName}
      screen={screenName}
      selectedDate={selectedDate}
      errors={errors}
      labelTranslationKey={labelTranslationKey}
      wrapperClassName={wrapperClassName}
      onChange={onChange}
    />
  )
}

export default StartRentalDate
